import {gql} from "@apollo/client";

export const UPDATE_SURVEY = gql`
mutation UpdateSurvey($survey_id: uuid!, $survey: String) {
  update_surveys(where: {id: {_eq: $survey_id}}, _set: {survey: $survey}) {
    affected_rows
  }
}
`;
